import { createLucideIcon } from 'lucide-react';
export const LockOpenIcon = createLucideIcon('lockOpen', [
  [
    'path',
    {
      d: 'M16.1034 10.7066L19 10.7066V20H5V10.7066H7.5L16.1034 10.7066Z',
      key: 'od4sf2',
    },
  ],
  [
    'path',
    {
      d: 'M16.1034 10.7066V7.5C16.1034 5.8912 15 5 14 4.5C13 4 10.7931 3.6259 9.3448 4.511C7.8966 5.3961 7.5 6.5 7.5 6.5',
      key: 'ose2ih',
    },
  ],
]);
